module.exports = __webpack_public_path__ + "img/blqProgram.13dfdf84.png";